import { capitalize } from "shared/utils";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { VerifiedItem } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified";

export const VerifiedReportedStats = ({
  currentItem
}: {
  currentItem?: VerifiedItem | VerifiedItem[];
}) => {
  const isGroupedItems = Array.isArray(currentItem);
  if (isGroupedItems) return null;

  return (
    <div className="space-y-3">
      {currentItem?.data &&
      "accounts" in currentItem.data &&
      currentItem.data.accounts[0] ? (
        <div className="space-y-3">
          <KeyValue
            label="Account ID"
            value={currentItem.data.accounts[0].account_id}
          />
        </div>
      ) : null}
      {currentItem?.data && "account" in currentItem.data ? (
        <>
          <KeyValue
            label="Bank account"
            value={
              capitalize(currentItem.data.account.type) +
              " ***" +
              currentItem.data.account.mask
            }
          />
          <KeyValue
            label="Institution"
            value={currentItem.data.account.name || "Unknown"}
          />

          <KeyValue
            label="Source bank account"
            value={
              capitalize(currentItem.data.account.type) +
              " ***" +
              currentItem.data.account.mask
            }
          />
        </>
      ) : null}
    </div>
  );
};
